export function jsonStringify(object) {
  for (const property in object) {
    if (object[property] === "" || object[property] === null) {
      delete object[property];
    }
  }

  return JSON.stringify(object);
}
